/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './repost.defs.js'
export { main as default } from './repost.defs.js'
